<template lang="pug">
    include ../../media/pug/mixins
    +b.order-view(
        v-bar="true"
    )
        +e.container
            +e.text-wrapper(v-if="!getOrderId")
                +e.text {{ $t('TO_ADD_ORDER') }}
            +e.scroll-container(v-else)
                cart-item(
                    v-for="item in 3"
                    v-bind:key="item"
                    v-bind:themeFull="true"
                )

</template>

<script>
import { mapGetters } from 'vuex';
import CartItem from '@/components/modules/CartItem';

export default {
    components: {
        CartItem
    },
    computed: {
        ...mapGetters([
            'getOrderId'
        ])
    }
    // феч информации о заказе следует делать на watch id заказа
};
</script>

<style lang="sass" src="@/media/sass/components/document-views/order-view.sass"></style>
